
const MAX_CHAR_LENGTH = 14;

export function shouldTruncate(text, maxChars = MAX_CHAR_LENGTH) {
  return !!(text && text.length > maxChars);
}

export default function truncateText(text, maxChars = MAX_CHAR_LENGTH) {
  return shouldTruncate(text, maxChars) ? `${text.slice(0, maxChars)}…` : text;
}
